<template>
  <div class="input-wrapper">
    <span class="input-icon" v-if="isCouponField">
      <img src="@/assets/images/intermarche/coupon-icon.png" alt="Coupon" width="23">
    </span>
    <input 
      :type="fieldType" 
      :value="modelValue" 
      @input="$emit('update:modelValue', $event.target.value)" 
      :placeholder="placeholder" 
      :title="hasError && errorMessage ? errorMessage : ''"
      :class="[
        hasError ? 'has-error' : '', 
        $i18n.locale === 'ar' ? 'arabic-text' : '',
        isCouponField ? 'set-left-padding' : ''
      ]"
      :required="isRequiredValue"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
export default {
  name: 'TextInputField',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    fieldType: {
      type: String,
      default: 'text'
    },
    isRequiredValue: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isCouponField: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.input-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
}

.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

input {
  width: 100%;
  padding: 0.55rem 0.55rem 0.55rem 0.55rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
  line-height: 1.5;
  font-size: 14px;
}

.set-left-padding {
  padding-left: 2.5rem;
}

input::placeholder {
  color: #020076;
}

input.arabic-text::placeholder {
  text-align: right;
  direction: rtl;
}

input.arabic-text {
  direction: ltr;
  text-align: left;
}
</style>
